import axios from "axios";
import i18n from "./i18n";

const axiosClient = axios.create({
  baseURL: "https://api.arcelia.sa/api/",
  // baseURL: "http://127.0.0.1:8000/api/",
});

axiosClient.defaults.headers.common = {
  "Content-Type": "application/json",
};

axiosClient.interceptors.request.use((config) => {
  config.headers["Content-Language"] = i18n.language ?? "ar";
  return config;
});

export default axiosClient;
